import React from "react";
import { useTranslation } from "react-i18next";

import Tooltip from "components/Tooltip";

interface Props {
  disabled?: boolean;
  icons: {
    url: string;
    value: string;
  }[];
  activeValue?: string;
  handleClick: (v: string) => void;
}

const ToggleBtn: React.FC<Props> = ({
  disabled,
  icons,
  handleClick,
  activeValue,
}) => {
  const { t } = useTranslation();

  const getLabel = (value: string) =>
    value === "grid" ? t("showAsGrid") : t("showAsList");

  return (
    <div className={`toggle-btn-wrapper ${disabled ? "disabled" : ""}`}>
      {icons.map((el) => {
        const label = getLabel(el.value);

        return (
          <Tooltip key={el.value} text={label} position="top" asChild>
            <div
              className={`toggle-btn-item ${activeValue === el.value ? "active" : ""}`}
              role="button"
              tabIndex={disabled ? -1 : 0}
              aria-label={label}
              aria-pressed={activeValue === el.value}
              aria-disabled={disabled}
              onClick={() => {
                if (!disabled) {
                  handleClick(el.value);
                }
              }}
              onKeyDown={(event) => {
                if (!disabled && (event.key === "Enter" || event.key === " ")) {
                  event.preventDefault();
                  handleClick(el.value);
                }
              }}
            >
              <img src={el.url} alt="" />
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default ToggleBtn;
